import React from 'react';
import Link from 'next/link';
import sentry from '../utils/sentry';
import { ButtonLink } from '../components/ButtonLink.jsx';
import { GlobalPage } from '../components/GlobalPage.jsx';
import { Container, Header, Footer, Layout } from '../components/layout/';

const { Sentry } = sentry();

export default function ErrorPage({ statusCode = null, errorEventId = null }) {
  return (
    <GlobalPage
      title={statusCode === 404 ? 'Siden ble ikke funnet' : 'Noe gikk galt'}
    >
      <Layout>
        <Container>
          {statusCode === 404 && (
            <div className="notFound">
              <h1>Siden ble ikke funnet</h1>
              <p>Hei! Siden du leter etter har blitt fjernet eller flyttet.</p>
              <p>
                Penger.no har nemlig blitt relansert, og er nå et samarbeid
                mellom VG, E24 og Dine Penger, og er eid av Verdens Gang AS.
              </p>
              <p>
                Savner du noe fra gamle Penger.no? Da finner du det mest
                sannsynlig på{' '}
                <a href="https://www.finn.no/okonomi">FINN økonomi</a>.
              </p>
              <p>
                Klikk{' '}
                <Link href="/">
                  <a>her</a>
                </Link>{' '}
                for å gå til forsiden for å finne ut mer om hva nye Penger.no
                er.
              </p>
              <p>
                <ButtonLink href="/">Gå til forsiden</ButtonLink>
              </p>
              <p>
                <ButtonLink href="/boliglan">
                  Gå til boliglåns&shy;sjekken
                </ButtonLink>
              </p>
            </div>
          )}
          {errorEventId && (
            <>
              <h1>Noe gikk galt</h1>
              <h2>Hva nå?</h2>
              <p>
                <a
                  href="#"
                  onClick={() =>
                    Sentry.showReportDialog({
                      eventId: errorEventId,
                      lang: 'no',
                    })
                  }
                >
                  📣 Rapporter feilen til oss
                </a>
              </p>
              <p>
                <a
                  href="#"
                  onClick={() => {
                    window.location.reload(true);
                  }}
                >
                  Last siden på nytt
                </a>
              </p>
              <hr />
              <p>
                Feilkode: <code>{statusCode}</code>
              </p>
              <p>
                Identifikasjon: <code>{errorEventId}</code>
              </p>
            </>
          )}
        </Container>
      </Layout>
      <style jsx>{`
        .notFound {
          max-width: 800px;
          line-height: 1.5;
          font-size: 18px;
        }

        .notFound p {
          margin: 22px 0;
        }
      `}</style>
    </GlobalPage>
  );
}

ErrorPage.getInitialProps = async function({ res, err }) {
  const statusCode = res ? res.statusCode : err ? err.statusCode : null;

  return {
    statusCode,
  };
};
